import {
  API_BASE_IMMUNIZATION_URL,
  API_IMMUNIZATION_LIST,
  API_IMMUNIZATION_DETAILS,
  API_IMMUNIZATION_CREATE,
  API_IMMUNIZATION_UPDATE,
  API_IMMUNIZATION_DELETE,
  API_IMMUNIZATION_BY_PATIENT,
  API_IMMUNIZATION_STATS,
  API_IMMUNIZATION_UPCOMING,
} from "../../../../helpers/urlHelper";

class ImmunizationService {
  
  // ========================================================================
  // 📋 OBTENER TODAS LAS INMUNIZACIONES
  // ========================================================================
  static async getAllImmunizations(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const url = `${API_BASE_IMMUNIZATION_URL}${API_IMMUNIZATION_LIST}${queryParams ? `?${queryParams}` : ''}`;
      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": `Bearer ${token}` // Cuando implementes auth
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error al obtener inmunizaciones:", error);
      throw error;
    }
  }

  // ========================================================================
  // 🔍 OBTENER INMUNIZACIÓN POR ID
  // ========================================================================
  static async getImmunizationById(id) {
    try {
      const response = await fetch(`${API_BASE_IMMUNIZATION_URL}${API_IMMUNIZATION_DETAILS}/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": `Bearer ${token}` // Cuando implementes auth
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Error al obtener inmunización ${id}:`, error);
      throw error;
    }
  }

  // ========================================================================
  // 👤 OBTENER INMUNIZACIONES POR PACIENTE
  // ========================================================================
  static async getImmunizationsByPatient(patientId, params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const url = `${API_BASE_IMMUNIZATION_URL}${API_IMMUNIZATION_BY_PATIENT}/${patientId}${queryParams ? `?${queryParams}` : ''}`;
      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": `Bearer ${token}` // Cuando implementes auth
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Error al obtener inmunizaciones del paciente ${patientId}:`, error);
      throw error;
    }
  }

  // ========================================================================
  // 📊 OBTENER ESTADÍSTICAS DE INMUNIZACIONES
  // ========================================================================
  static async getImmunizationStats(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const url = `${API_BASE_IMMUNIZATION_URL}${API_IMMUNIZATION_STATS}${queryParams ? `?${queryParams}` : ''}`;
      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": `Bearer ${token}` // Cuando implementes auth
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error al obtener estadísticas de inmunizaciones:", error);
      throw error;
    }
  }

  // ========================================================================
  // 📅 OBTENER VACUNAS PRÓXIMAS
  // ========================================================================
  static async getUpcomingVaccinations(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const url = `${API_BASE_IMMUNIZATION_URL}${API_IMMUNIZATION_UPCOMING}${queryParams ? `?${queryParams}` : ''}`;
      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": `Bearer ${token}` // Cuando implementes auth
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error al obtener vacunas próximas:", error);
      throw error;
    }
  }

  // ========================================================================
  // ➕ CREAR NUEVA INMUNIZACIÓN
  // ========================================================================
  static async createImmunization(immunizationData) {
    try {
      const response = await fetch(`${API_BASE_IMMUNIZATION_URL}${API_IMMUNIZATION_CREATE}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": `Bearer ${token}` // Cuando implementes auth
        },
        body: JSON.stringify(immunizationData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error al crear inmunización:", error);
      throw error;
    }
  }

  // ========================================================================
  // ✏️ ACTUALIZAR INMUNIZACIÓN
  // ========================================================================
  static async updateImmunization(id, immunizationData) {
  try {
    const response = await fetch(`${API_BASE_IMMUNIZATION_URL}${API_IMMUNIZATION_UPDATE}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        // "Authorization": `Bearer ${token}` // Cuando implementes auth
      },
      body: JSON.stringify(immunizationData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error al actualizar inmunización ${id}:`, error);
    throw error;
  }
}

  // ========================================================================
  // 🗑️ ELIMINAR INMUNIZACIÓN
  // ========================================================================
  static async deleteImmunization(id) {
    try {
      const response = await fetch(`${API_BASE_IMMUNIZATION_URL}${API_IMMUNIZATION_DELETE}/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": `Bearer ${token}` // Cuando implementes auth
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Error al eliminar inmunización ${id}:`, error);
      throw error;
    }
  }

  // ========================================================================
  // 🔄 MÉTODOS AUXILIARES
  // ========================================================================
  
  // Validar datos de inmunización antes de enviar
  static validateImmunizationData(data) {
    const errors = [];
    
    if (!data.vaccinename || data.vaccinename.trim() === "") {
      errors.push("El nombre de la vacuna es requerido");
    }
    
    if (!data.patient) {
      errors.push("El ID del paciente es requerido");
    }
    
    if (!data.dateadministered || data.dateadministered.trim() === "") {
      errors.push("La fecha de administración es requerida");
    }
    
    return {
      isValid: errors.length === 0,
      errors: errors
    };
  }

  // Formatear datos de inmunización para envío
  static formatImmunizationData(data) {
    return {
      vaccinename: data.vaccinename?.trim(),
      patient: data.patient,
      dateadministered: data.dateadministered,
      dose: data.dose || null,
      administeredby: data.administeredby?.trim() || null,
      location: data.location?.trim() || null,
      lotnumber: data.lotnumber?.trim() || null,
      manufacturer: data.manufacturer?.trim() || null,
      notes: data.notes?.trim() || null,
      nextduedate: data.nextduedate || null,
      route: data.route?.trim() || null,
      site: data.site?.trim() || null,
    };
  }
}

export default ImmunizationService;